
import { SEO } from '../../utils/seo';
import GlobalNavbar from '../../components/feature/GlobalNavbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import BlogDirectorySection from './components/BlogDirectorySection';
import IntroSection from './components/IntroSection';
import LocalExpertiseSection from './components/LocalExpertiseSection';
import WhyElPasoSection from './components/WhyElPasoSection';
import OurProcessSection from './components/OurProcessSection';
import NeighborhoodsSection from './components/NeighborhoodsSection';
import PropertyTypesSection from './components/PropertyTypesSection';
import CashBuyingSection from './components/CashBuyingSection';
import LocalMarketSection from './components/LocalMarketSection';
import CommunityCommitmentSection from './components/CommunityCommitmentSection';
import SuccessStoriesSection from './components/SuccessStoriesSection';
import CTASection from './components/CTASection';

const ElPasoTXPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="El Paso TX Cash Home Buyers | We Buy Houses Fast | TREX RE LLC"
        description="El Paso TX Home Buyers - Real Local Property Buyers offering fast cash for homes in El Paso, Texas. We buy houses in any condition across all El Paso neighborhoods. Get your fair cash offer today."
        keywords="El Paso home buyers, sell house fast El Paso TX, cash for homes El Paso, we buy houses El Paso, local property buyers Texas"
        canonical="/elpaso-tx"
        schema={{
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "TREX RE LLC - El Paso",
          "description": "Local cash home buyers serving El Paso, TX and surrounding areas",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "El Paso",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "areaServed": "El Paso, TX"
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <BlogDirectorySection />
      <IntroSection />
      <LocalExpertiseSection />
      <WhyElPasoSection />
      <OurProcessSection />
      <NeighborhoodsSection />
      <PropertyTypesSection />
      <CashBuyingSection />
      <LocalMarketSection />
      <CommunityCommitmentSection />
      <SuccessStoriesSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default ElPasoTXPage;
